import styles from "./DecorativeText.module.scss";

type DecorativeTextProps = {
  text: string;
  backgroundImage: string;
};

/**
 * Displays large font text with a background image filling the text
 *
 * Usage
 *
 * ```tsx
 * import image from "@/assets/stories/diagnostic-image.jpg"
 *
 * <DecorativeText text="Hello World" backgroundImage={image} />
 * ```
 */
export const DecorativeText: React.FC<DecorativeTextProps> = ({ text, backgroundImage }) => (
  <div className={styles.container}>
    <div className={styles.backgroundImage} style={{ backgroundImage: `url(${backgroundImage})` }}>
      <span className={styles.text}>{text}</span>
    </div>
  </div>
);
